/**************************************************
 * Nombre:       Seccion_Escuela_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Escuela_Detalle_Portada from "./Componentes/Escuela_Detalle_Portada";
import Escuelas_QueProgramas from "./Componentes/Escuelas_QueProgramas";
import Escuela_Beneficios from "./Componentes/Escuela_Beneficios";
import Escuela_Comunidad from "./Componentes/Escuela_Comunidad";
import {useContext, useEffect, useState} from "react";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useParams} from "react-router-dom";
import {contexApp} from "../../App";
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Escuela_Detalle = () => {
    const cData = useContext(contexApp)
    const parms = useParams()
    const {sCell} = useResponsive()
    const [escuela, setEscuela] = useState({})

    useEffect(() => {

        irArriba()
        if (parms && parms.id) {
            let escuelas = cData.escuelas
            let index = escuelas.findIndex((e) => e.nombre === parms.id.replaceAll('-', ' '))
            if (index >= 0) {
                setEscuela(escuelas[index])
            }

        }

    }, [parms, cData])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -1 : 0}}>
                <Escuela_Detalle_Portada item={escuela}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 0 : 8}}>
                <Escuelas_QueProgramas item={escuela}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 18}}>
                <Escuela_Beneficios item={escuela}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 18}}>
                <Escuela_Comunidad item={escuela}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 12 : 20}}>
                <Home_Testimonios/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Escuela_Detalle